import Lives from 'views/Lives'

const HighRiskLives = () => {
    return (
        <Lives highRisk={true} />
    )
}

export default HighRiskLives